import { render, staticRenderFns } from "./formMdAndA.vue?vue&type=template&id=25490186&scoped=true"
import script from "./formMdAndA.vue?vue&type=script&lang=js"
export * from "./formMdAndA.vue?vue&type=script&lang=js"
import style0 from "./formMdAndA.vue?vue&type=style&index=0&id=25490186&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25490186",
  null
  
)

export default component.exports